module.exports = __webpack_public_path__ + "images/application/logo-ac-blue-white-64a0e580.svg";